<template>
  <Banner
    :id="id"
    :content="content"
    :visible="visible"
    :background-color="backgroundHexColor"
    :data-ab-id="props?.dataABId"
  />
</template>

<script lang="ts" setup>
import { WrapperProps } from './Banner.model';
import Banner from './Banner.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

// eslint-disable-next-line vue/prop-name-casing
const props = defineProps({ ...WrapperProps, '@id': String });

const id = toRef(props, '@id');
const visible = !(props.isHidden ?? false) || Object.hasOwn(useRoute().query, 'mgnlPreview');
const backgroundHexColor = magnoliaGetters.getHexColor(props.backgroundColor);
</script>
